import { RawAxios, SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const BASE_PATH = `${API_ROOT}/auth`;
const PATHS = {
    LOGIN: `${BASE_PATH}/login`,
    LOGOUT: `${BASE_PATH}/logout`,
    REFRESH_TOKEN: `${BASE_PATH}/refresh_token`,
};
async function login(email, password) {
    return (await RawAxios().post(PATHS.LOGIN, { email, password })).data;
}
async function logout() {
    return await RawAxios().post(PATHS.LOGOUT);
}
async function refreshToken() {
    return (await (await SecureAxios()).get(PATHS.REFRESH_TOKEN)).data;
}
export default { login, logout, refreshToken };
